module.exports = __webpack_public_path__ + "static/30-92bf99f7e1abc0e4d155ad1573e9b67b.png";